// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2dNlT","rootCenter":"LoadMoreObserver_rootCenter__hto8C","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Yjuu"};